import { render, staticRenderFns } from "./SectionsButton.vue?vue&type=template&id=e0133a46&scoped=true&"
import script from "./SectionsButton.vue?vue&type=script&lang=js&"
export * from "./SectionsButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0133a46",
  null
  
)

export default component.exports